import { isExternal, toRelativeUrl } from "./../../helpers/url.js";
import { useRouter } from "#imports";
export function useClickTriggerProxy(options) {
  function onClick(e) {
    if (!e.target || !("href" in e.target)) {
      return;
    }
    const target = e.target;
    const href = target.href;
    if (isExternal(href, window.location.origin)) {
      return;
    }
    if (options && options.isExternal && options.isExternal(href)) {
      return;
    }
    if (href.startsWith("#")) {
      return;
    }
    e.preventDefault();
    const router = useRouter();
    router.push(toRelativeUrl(href));
  }
  return { onClick };
}
